import React from 'react';
import { Chip, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * Individual tag chip component with optional delete functionality
 */
export default function TagChip({ 
  tag, 
  onDelete, 
  size = 'small',
  variant = 'filled',
  showDelete = false 
}) {
  return (
    <Chip
      label={tag.name}
      size={size}
      variant={variant}
      sx={{
        backgroundColor: tag.color || '#1976d2',
        color: 'white',
        '& .MuiChip-deleteIcon': {
          color: 'white',
        },
        fontSize: '0.75rem',
        height: '24px',
      }}
      deleteIcon={showDelete ? <CloseIcon /> : undefined}
      onDelete={showDelete && onDelete ? () => onDelete(tag.id) : undefined}
    />
  );
}
